import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import TagSource from 'sources/TagSource';

class TagActions {
  constructor() {
    this.generateActions('clearTags', ...generateAsyncActions('fetchTags'));
  }
  fetchTags(filters) {
    return dispatch => {
      dispatch(filters);
      return TagSource.fetchTags(filters).then(
        tags => this.fetchTagsSuccess([filters, tags]),
        error => {
          this.fetchTagsError(filters);
          throw error;
        }
      );
    };
  }
}

export default alt.createActions(TagActions);
